import style from './AutoGrowTextarea.module.scss'

type Props = {
  wrapperClassName?: string
  enterToSubmit?: boolean
  ref?: Ref<HTMLTextAreaElement | null>
} & ComponentProps<'textarea'>

const AutoGrowTextarea = memo(function AutoGrowTextarea({ref, ...props}: Props) {
  const textareaGrowerRef = useRef<HTMLDivElement>(null)
  const textAreaProps = {...props}

  delete textAreaProps.wrapperClassName
  delete textAreaProps.enterToSubmit
  delete textAreaProps.disabled

  useLayoutEffect(() => {
    if (textareaGrowerRef.current) {
      let stringValue: string | undefined
      if (typeof props.value === 'string') {
        stringValue = props.value
      } else if (typeof props.value === 'number') {
        stringValue = String(props.value)
      } else if (Array.isArray(props.value)) {
        stringValue = props.value.join('')
      }
      if (stringValue !== undefined) textareaGrowerRef.current.dataset.replicatedValue = stringValue
    }
  }, [props.value])

  return (
    <div className={clsx(style.GrowWrapper, props.wrapperClassName)} ref={textareaGrowerRef}>
      <textarea
        {...textAreaProps}
        aria-disabled={props.disabled}
        ref={ref}
        onChange={e => {
          if (!props.disabled) {
            if (textareaGrowerRef.current)
              textareaGrowerRef.current.dataset.replicatedValue = e.currentTarget.value
            props.onChange?.(e)
          }
        }}
        onKeyDown={e => {
          if (props.onKeyDown) {
            props.onKeyDown(e)
          } else if (
            e.key === 'Enter' &&
            !e.shiftKey &&
            !props.disabled &&
            props.enterToSubmit === true
          ) {
            // If not Shift + Enter, then submit
            e.preventDefault()
            e.currentTarget.form?.requestSubmit()
          }
        }}
      />
    </div>
  )
})

export default AutoGrowTextarea
